module.exports = __webpack_public_path__ + "img/im.f136875f.svg";